import moment from 'moment';

export default function transformSystemStatusFilters(filters = {}) {
    const newFilters = {};
    let filtersCount = 0;
    const { createdFilter, infoTypeId, infoGroupName, createdGreaterThan, createdLesserThan } = filters;

    switch (createdFilter) {
        case 'customrange':
            newFilters.createdGreaterThan = createdGreaterThan;
            newFilters.createdLesserThan = createdLesserThan;
            filtersCount = 2;
            break;
        case 'today':
            filtersCount = 1;
            newFilters.createdGreaterThan = moment()
                .startOf('day')
                .toDate();
            break;
        case 'yesterday':
            filtersCount = 1;
            newFilters.createdGreaterThan = moment()
                .subtract(1, 'days')
                .toDate();
            newFilters.createdLesserThan = moment()
                .startOf('day')
                .toDate();
            break;
        case 'lastweek':
            filtersCount = 1;
            newFilters.createdGreaterThan = moment()
                .subtract(7, 'days')
                .toDate();
            break;
        case 'previousweek':
            filtersCount = 2;
            newFilters.createdGreaterThan = moment()
                .subtract(14, 'days')
                .toDate();
            newFilters.createdLesserThan = moment()
                .subtract(7, 'days')
                .toDate();
            break;
        default:
    }

    if (infoTypeId && infoTypeId !== '') {
        newFilters.infoTypeId = infoTypeId;
        filtersCount++;
    }


    if (infoGroupName && infoGroupName !== '') {
        newFilters.infoGroupName = infoGroupName;
        filtersCount++;
    }
    return newFilters;
}